import { createContext, useContext, useState } from "react";
import { sendData } from "../../../lib/dashboard/actions";
import { useSubscriptionContext } from "../SubscriptionContext";

const OrdersContext = createContext()


export default function OrdersProvider({ children }) {
    const { selectedPlan } = useSubscriptionContext();

    const [showConfirmationForm, setShowConfirmationForm] = useState(false);
    const [isLoading, setIsLoading] = useState({
        discountApply: false,
        payBill: false,
    });
    const [receiptId, setReceiptId] = useState("");
    const [discountCode, setDiscountCode] = useState("");
    const [plansData, setPlansData] = useState(null);


    // get receipt id after enter discount code
    const handleGetReceiptId = async () => {
        setIsLoading((prev) => ({ ...prev, discountApply: true }))
        const result = await sendData({ plan_id: selectedPlan?.id, code: discountCode }, "/account/pricing");
        if (result?.status === 200) {
            setReceiptId(result?.data.receipt_id)
            setPlansData(result?.data)
        }
        setIsLoading((prev) => ({ ...prev, discountApply: false }))
    };

    return (
        <OrdersContext.Provider value={{ plansData, showConfirmationForm, setShowConfirmationForm, isLoading, setIsLoading, handleGetReceiptId, receiptId, discountCode, setDiscountCode }}>{children}</OrdersContext.Provider>
    )
}

export function useOrdersContext() { return useContext(OrdersContext) }